import './AdBox.css';
import React, {useContext} from 'react';
import { AppContext } from '../AppContext';
import {useLocation} from "react-router-dom";

class AdBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _ad_init_done: false,
            ad_id: `reklaami_${Date.now()}`,
        };
    }

    componentWillUnmount() {
        // This comes AFTER UPDATING THE COMPONENT -> can not call destroySlots() or will lose ads
        /*console.error('[AdBox->componentWillUnmount()] CALLED'); // DEBUG
        if (window.relevantDigital && relevantDigital.destroySlots) {
            // @see https://help.relevant-digital.com/knowledge/relevantdigital.destroyslots
            relevantDigital.destroySlots();
            this.setState({
                _ad_init_done: false,
            });
            //window._ad_init_done = false;
        }*/
    }

    componentDidMount() {
        //this.popMediaAds();
    }

    componentDidUpdate(prevProps, prevState) {
        this.updateAds();
    }

    async updateAds() {
        const uri = this.props.location.pathname;
        for (const adId of Object.keys(window._adSlotState)) {
            if (window._adSlotState[adId] === uri) {
                // Already rendered ads for this URI, no need to update
                continue;
            }
            //console.error('googleAds navigated to new uri: ', `${uri}`); // DEBUG
            const adElement = document.getElementById(adId);
            if (!adElement) {
                // Ad element not in DOM
                //console.error('Element not available for: ', `${adId}`); // DEBUG
                continue;
            }
            /*if (window._adSlots[adId] && window._adSlotState[adId] !== false) {
                console.error('Destroying slot: ' + adId); // DEBUG
                await googletag.destroySlots([window._adSlots[adId]]);
                delete window._adSlots[adId];
                adElement.replaceChildren(); // Remove contents
            }*/
            if (!window._adSlots[adId]) {
                //console.error('Adding slot: ' + adId); // DEBUG
                await window._adSlotProvider(adId);
                //console.error('Slot added: ' + adId, window._adSlots[adId]); // DEBUG
                if (window._adSlots[adId] === false) {
                    // This ad slot is not used on this device, e.g. desktop ad slot for mobile etc.
                    continue;
                }
                if (window._adSlots[adId] === null) {
                    //console.error('Failed to add ad slot: ' + adId + ', will retry'); // DEBUG
                    continue; // Retry later, DOM hasn't updated and ad slot could not be re-created
                }
            }
            window._adSlotState[adId] = uri;
            /*this.setState({
                _ad_init_done: false,
            });*/
            //console.error('servePopMediaAds() for: ', `${adId}`); // DEBUG
            setTimeout(() => {
                this.servePopMediaAds([adId]);
            }, 50);
            // @todo: need to call googletag.cmd.push(function() {googletag.display(adId);}); for new article ad places?
            /*googletag.cmd.push(() => {
                if (adId === 'div-gpt-ad-1747240470688-0') {
                    window._adSlots['div-gpt-ad-1747240470688-0'] = googletag.defineSlot('/22871113322/pelcom_artikkeli_paikka_1', [(window.innerWidth < 980 ? [351, 117] : [750, 250])], 'div-gpt-ad-1747240470688-0').addService(googletag.pubads());
                } else {
                    window._adSlots['div-gpt-ad-1747243260061-0'] = googletag.defineSlot('/22871113322/pelcom_artikkeli_paikka_2', [(window.innerWidth < 980 ? [351, 117] : [750, 250])], 'div-gpt-ad-1747243260061-0').addService(googletag.pubads());
                }
            });*/
            //googletag.cmd.push(function() {googletag.display(adId);});
            /*const is_refresh = (window._adSlotState[adId] !== false);
            window._adSlotState[adId] = uri;
            if (!is_refresh) {
                console.error('Adding slot: ' + adId); // DEBUG

            } else if (googletag?.pubads) {
                console.error('Refreshing slot: ' + adId); // DEBUG
                googletag.cmd.push(() => {
                    googletag.pubads().refresh(
                        [window._adSlots[adId]] //, // Only this slot
                        //{ changeCorrelator: true }
                    );
                });
            }*/
        }
    }

    getDevice() {
        return window.innerWidth < 980 ? 'mobile' : 'desktop';
    }

    injectDeviceInfoIntoPopMediaAds() {
        let elements_ok = false;
        const type = this.getDevice();
        ["data-lazy-" + type + "-ad-unit-id", "data-" + type + "-ad-unit-id"].forEach((attr) => {
            Array.from(document.querySelectorAll("["+ attr + "]")).forEach((elm) => {
                elements_ok = true
                if (elm.getAttribute('data-slot-rendered') === "true") {
                    return;
                }
                elm.setAttribute(attr.replace(type + "-", ""), elm.getAttribute(attr));
                elm.setAttribute('data-slot-rendered', 'true');
            });
        });
        return elements_ok;
    }

    servePopMediaAds(divIds) {
        const loadPreBid = function(divIds) {
            const preBidPayload = { // https://help.relevant-digital.com/knowledge/relevantdigital.loadprebid
                configId: '63e4ae374cc636ac3cc16da7', //pelaajatcom config id
                delayedAdserverLoading: false,
                manageAdserver: true,
                collapseEmptyDivs: false,
                collapseBeforeAdFetch: false,
                loadUnknownSlots: true,
                noSlotReload: false,
                noAdsInitRequestAll: true,
                noGpt: true,
                allowedDivIds: divIds,
            };
            relevantDigital.loadPrebid(preBidPayload);
        };

        if (!relevantDigital?.loadPrebid) {
            relevantDigital.cmd.push(() => {
                loadPreBid(divIds);
            });
        } else {
            loadPreBid(divIds);
        }
    }

    getGoogleAdDiv(adId) {
        if (window._adMinSizes[adId][this.getDevice()] === null) {
            return '';
        }
        return `<div id='${adId}' style='zoom: ${window._adMinSizes[adId][this.getDevice()]['width'] === 351 ? ((window.innerWidth - 15) / 750) : '1.0'}; min-width: ${window._adMinSizes[adId][this.getDevice()]['width']}px; min-height: ${window._adMinSizes[adId][this.getDevice()]['height']}px;'></div>`;
    }

    render() {
        if (!this.props?.position) {
            return null;
        }
        let ad;
        switch (this.props.position) {
            case 'home':
                // <!-- /22871113322/pelcom_etusivu_paikka_1 --> + <!-- /22871113322/pelcom_etusivu_paikka_2 -->
                ad = {html: this.getGoogleAdDiv('div-gpt-ad-1747508139656-0') + this.getGoogleAdDiv('div-gpt-ad-1747508358296-0')};
                break;
            case 'article':
                // <!-- /22871113322/pelcom_artikkeli_paikka_1 --> + <!-- /22871113322/pelcom_artikkeli_paikka_2 -->
                ad = {html: this.getGoogleAdDiv('div-gpt-ad-1747240470688-0') + this.getGoogleAdDiv('div-gpt-ad-1747243260061-0')};
                break;
            case 'sidebar':
                // <!-- /22871113322/pelcom_artikkeli_paikka_1 --> + <!-- /22871113322/pelcom_artikkeli_paikka_2 -->
                ad = {html: this.getGoogleAdDiv('div-gpt-ad-1746988909470-0')};
                break;
            case 'community':
                // <!-- /22871113322/pelaajatcom_outstream_1_1 -->
                ad = {html: this.getGoogleAdDiv('div-gpt-ad-1747471554813-0')};
                break;
        }
        if (ad?.html && ad?.html !== '') {
            return (
                <div className="Ad-Box" dangerouslySetInnerHTML={{__html: ad.html}}/>
            );
        }
        // Legacy: to be removed once frontpage ads have been moved to Ad Manager
        if (!this.props?.context?.components?.reklaami) {
            return null;
        }
        ad = this.props.context.components.reklaami[this.props.position];
        if (!ad) {
            return null;
        }

        if (ad.html) {
            return (
                <div className="Ad-Box" dangerouslySetInnerHTML={{__html: ad.html}}/>
            );
        }

        let ad_content = null;
        if (ad.img_url) {
            ad_content = (
                <img src={ad.img_url} alt="Mainos" />
            );
        }
        if (ad.img_link) {
            ad_content = (
                <a href={ad.img_link} target="_blank" rel="nofollow">
                    {ad_content}
                </a>
            );
        }

        return (
            <div className="Ad-Box">
                {ad_content}
            </div>
        );
    }
}

const AdBoxWithContext = (props) => {
    const context = useContext(AppContext);
    const location = useLocation();
    return (<AdBox {...props} context={context} location={location} />);
};

export default AdBoxWithContext;
